import { useMutation } from '@apollo/client';
import type { InsertScimTokenMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { InsertScimTokenDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { useIsFeatureFlagEnabled } from '@/hooks/useIsFeatureFlagEnabled';
import { evictField } from '@/utils/graphqlUtils';

import { useInsertScimTokenTRPC } from './useInsertScimTokenTRPC';

type InsertScimTokenInput = { expireInMonths: '6' | '12' | '24' };

export const useInsertScimToken = () => {
  const trpcEnabled = useIsFeatureFlagEnabled('trpc');

  const [insertScimTokenGraphQL, graphqlState] = useMutation(
    InsertScimTokenDocument,
    {
      update: (cache) => {
        evictField(cache, 'getScimConfig');
      },
    }
  );

  const trpcMutation = useInsertScimTokenTRPC();

  const insertScimToken = async (
    variables: InsertScimTokenInput
  ): Promise<InsertScimTokenMutation> => {
    if (trpcEnabled) {
      return trpcMutation.insertScimToken(variables);
    }

    const result = await insertScimTokenGraphQL({ variables });
    if (!result.data) {
      throw new Error('Failed to issue SCIM token');
    }

    return result.data;
  };

  return {
    insertScimToken,
    loading: trpcEnabled ? trpcMutation.loading : graphqlState.loading,
    error: trpcEnabled ? trpcMutation.error : graphqlState.error,
  };
};
